import * as DROPDOWN from 'constant/dropdown'
import { Dropdown, Menu } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import React from 'react'
import PropTypes from 'prop-types'
import DeleteUser from 'view/page/user-management/component/delete-user'
import EditUser from 'view/page/user-management/component/edit-user'
import DeactivateUser from 'view/page/user-management/component/deactivate-user'
import styles from './styles'

const Action = ({ user }) => {
  return (
    <span>
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item >
              <EditUser user={user} />
            </Menu.Item>
            <Menu.Item>
              <DeactivateUser user={user} />
            </Menu.Item>
            <Menu.Item>
              <DeleteUser user={user} />
            </Menu.Item>
          </Menu>
        }
        overlayStyle={{ zIndex: 1 }}
        trigger={[DROPDOWN.TRIGGER]}
      >
        <div className={styles.show_more}>
          <span>More</span>
          <DownOutlined />
        </div>
      </Dropdown>
    </span>
  )
}

Action.propTypes = {
  user: PropTypes.object
}

export default Action
